'use client';

import { Card, Label } from '@repo/ui';
import { DistributionGraph } from '../common/distribution-graph';
import { ScrollableContainer } from '../common/scrollable-container';

export interface BinomialResult {
  pdf: number;
  cdf: number;
  distribution: number[];
  successes: number[];
}

interface BinomialCalculatorProps {
  visualizationData: BinomialResult | null;
}

export function BinomialCalculator({ visualizationData: result }: BinomialCalculatorProps) {
  if (!result) {
    return null;
  }

  return (
    <ScrollableContainer>
      <div className="space-y-6">
        <Card className="p-4 rounded-lg">
          <h3 className="text-lg font-semibold mb-4">Binomial Distribution Results</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Probability Mass (PDF)</Label>
              <div>{result.pdf.toFixed(4)}</div>
            </div>
            <div>
              <Label>Cumulative Probability (CDF)</Label>
              <div>{result.cdf.toFixed(4)}</div>
            </div>
          </div>
        </Card>

        <Card className="p-4 rounded-lg">
          <h3 className="text-lg font-semibold mb-4">Probability Distribution</h3>
          <DistributionGraph
            data={result.distribution}
            title="Binomial Distribution"
            xAxisLabel="Number of Successes"
            yAxisLabel="Probability"
            height={300}
            binCount={result.successes.length}
            xAxisValues={result.successes}
            labels={[
              {
                value: result.successes[result.successes.length - 1] ?? 0,
                text: `P(X = k) = ${result.pdf.toFixed(4)}`,
                color: '#ff4d4d',
                lineStyle: 'solid'
              }
            ]}
          />
        </Card>
      </div>
    </ScrollableContainer>
  );
} 